export default `
  .hero-builder {
    margin-bottom: 60px;
  }
`;
